import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentFailed = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { message, showRetry } = location.state || {};

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <div className="text-center">
        <div className="text-danger mb-3">
          <i className="bi bi-x-circle-fill" style={{ fontSize: "3rem" }}></i>
        </div>
        <h2>{message || "Payment Verification Failed"}</h2>
        <p>We were unable to verify your payment. Please try again or contact support if the issue persists.</p>

        {showRetry && (
          <button
            className="btn btn-primary mt-3"
            onClick={() => navigate("/payment-retry")}
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};

export default PaymentFailed;
